// extracted by mini-css-extract-plugin
export default {"highlight":"styles_highlight__e5pB-","actionWrap":"styles_actionWrap__S8Eja","praise":"styles_praise__Pn0Cy","switchWrap":"styles_switchWrap__A3y2L"};